import _objectSpread from "@babel/runtime/helpers/objectSpread2";
export default function convertLink(component, mod, state) {
  var properties = component.properties;
  var props = properties;
  return {
    brick: "eo-link",
    properties: _objectSpread(_objectSpread({}, props), {}, {
      inApp: state.app.appType === "app",
      themeVariant: "elevo"
    })
  };
}
//# sourceMappingURL=convertLink.js.map